import { FormProps, Input } from '@alphabait/ui/form'

import i18n from '../../i18n'
import { AlphaTypes } from './custom-types'
import style from './form.module.css'

export default function CustomCheckbox({
  field,
  formProps,
}: {
  field: Input
  formProps: FormProps
}) {
  return (
    <input
      type="checkbox"
      placeholder={field.uiOptions?.placeholder}
      className={style.customInput}
      value={field.value}
      {...formProps?.register(field.name, {
        value: field.value,
      })}
      data-testid={field.uiOptions?.testId}
      disabled={field.uiOptions?.disabled}
    />
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export const getCustomCheckboxProperties = () =>
  [
    {
      name: 'uiOptions.label',
      type: 'input',
      uiOptions: {
        label: i18n.t('questionnaire_builder.question'),
        inputType: 'text',
      },
      validations: ['required'],
    },
    {
      name: 'validation.required',
      customControlType: 'switch',
      type: 'custom',
      uiOptions: {
        label: i18n.t('questionnaire_builder.required'),
      },
    },
  ] as AlphaTypes[]
